<template>
    <div>
        <Head title="Новий продукт"/>
        <h1 class="mb-8 text-3xl font-bold">
            <Link class="text-indigo-400 hover:text-indigo-600" :href="$route('products.index')">
                Продукти
            </Link>
            <span class="text-indigo-400 font-medium"> /</span> Новий продукт
        </h1>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="store">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name"
                                class="pb-8 pr-6 w-full" label="Назва"/>
                    <text-input v-model="form.price" :error="form.errors.price"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Ціна (грн)" type="number" step="0.01" min="0"/>
                    <text-input v-model="form.quantity" :error="form.errors.quantity"
                                class="pb-8 pr-6 w-full lg:w-1/2" label="Кількість" type="number" min="0"/>
                    <div class="pb-8 pr-6 w-full">
                        <label class="form-label" for="description">Опис</label>
                        <ckeditor :editor="editor" v-model="form.description" :config="editorConfig"
                                  id="description" class="description"/>
                    </div>
                    <drag-and-drop v-model="form.images" :error="form.errors.images"
                                   class="pb-8 pr-6 w-full lg:w-1/2"
                                   type="file" accept="image/*" label="Зображення"/>
                    <div class="pb-8 pr-6 w-full flex items-center">
                        <label class="form-label mr-4 mb-0">Активний</label>
                        <input type="checkbox" v-model="form.is_active" class="w-5 h-5"/>
                    </div>
                </div>
                <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">
                        Створити продукт
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import DragAndDrop from '@/Shared/DragAndDrop'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import CKEditor from '@ckeditor/ckeditor5-vue'

export default {
    components: {
        Head, Link, LoadingButton, TextInput, DragAndDrop,
        ckeditor: CKEditor.component,
    },
    layout: Layout,
    remember: 'form',
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {},
            form: this.$inertia.form({
                name: '',
                description: '',
                price: '',
                quantity: '',
                images: null,
                is_active: true,
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('products.store'))
        },
    },
}
</script>

<style scoped>
:deep(.ck.ck-editor__editable_inline) {
    min-height: 300px;
}
.description {
    width: 100%;
}
</style>
